import React from 'react';

export interface ChartTooltipPayloadItem {
  name?: string | number;
  value?: number | string;
  color?: string;
  dataKey?: string;
  payload?: Record<string, unknown>;
  [key: string]: unknown;
}

export interface ChartTooltipProps {
  active?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any[];
  label?: string | number;
  /** Format value for display, e.g. currency */
  formatValue: (value: number) => string;
  /** Label line title, e.g. "Date" */
  labelTitle?: string;
  /** Optional formatter for the label (e.g. timestamp → readable date) */
  labelFormatter?: (label: string | number) => string;
  /** Additional props from Recharts */
  [key: string]: unknown;
}

/**
 * Shared Recharts tooltip using design tokens. Use as content for Recharts <Tooltip content={...} />.
 */
const ChartTooltip: React.FC<ChartTooltipProps> = ({
  active,
  payload,
  label,
  formatValue,
  labelTitle = 'Date',
  labelFormatter,
}) => {
  if (!active || !payload?.length) return null;

  const displayLabel = labelFormatter ? labelFormatter(label ?? '') : label;

  return (
    <div className="chart-tooltip">
      <p className="chart-tooltip-label">{`${labelTitle}: ${displayLabel}`}</p>
      {payload.map((entry, index) => {
        const name = String(entry.name ?? '');
        const value = typeof entry.value === 'number' ? entry.value : 0;

        return (
          <p key={index} className="chart-tooltip-row" style={{ color: entry.color }}>
            <span>{name}:</span>
            <span className="chart-tooltip-value">{formatValue(value)}</span>
          </p>
        );
      })}
    </div>
  );
};

export default ChartTooltip;
